import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-title-page',
  templateUrl: './title-page.component.html',
  styleUrls: ['./title-page.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class TitlePageComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() centered?: boolean = false;

  constructor() { }

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/title-page/title-page.component.ts